import React from 'react';
import { ViewerTemplate } from '../ViewerTemplate';
import { ISimultaneousIssuePremiumData } from '../../../../../types/administration/pricing/underwriterProfileInterfaces/ISimultaneousIssuePremium';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { RateViewer } from '../shared/RateViewer';

const kindToName = {
  SimultaneousIssueFlatDto: 'Flat',
  SimultaneousIssuePercentBasicDto: 'Percent Basic',
  SimultaneousIssuePercentLenderDto: 'Percent Lender',
  SimultaneousIssueRateDto: 'Rate',
};

export const SimultaneousIssueViewer: React.FC<{ simultaneousIssue: ISimultaneousIssuePremiumData }> = ({
  simultaneousIssue,
}) => (
  <ViewerTemplate viewerName={`Simultaneous Issue, ${kindToName[simultaneousIssue.kind]}:`}>
    <ViewSelector simultaneousIssue={simultaneousIssue} />
  </ViewerTemplate>
);

const ViewSelector: React.FC<{ simultaneousIssue: ISimultaneousIssuePremiumData }> = ({ simultaneousIssue }) => {
  switch (simultaneousIssue.kind) {
    case 'SimultaneousIssueFlatDto':
      return <LabelValueViewer label={'premium'} value={simultaneousIssue.premium} />;
    case 'SimultaneousIssuePercentBasicDto':
      return (
        <>
          <LabelValueViewer label={'premium'} value={simultaneousIssue.premium} />
          <LabelValueViewer label={'percent of basic'} value={simultaneousIssue.percentOfBasic} />
        </>
      );
    case 'SimultaneousIssuePercentLenderDto':
      return (
        <>
          <LabelValueViewer label={'premium'} value={simultaneousIssue.premium} />
          <LabelValueViewer label={'percent of lender'} value={simultaneousIssue.percentOfLender} />
          <LabelValueViewer label={'minimum'} value={simultaneousIssue.minimum} />
        </>
      );
    case 'SimultaneousIssueRateDto':
      return <RateViewer rate={simultaneousIssue.rate} title={'Simultaneous Issue'} />;
  }
};
